import _ from 'lodash';
import { useState } from 'react';
import classNames from 'classnames';

import PopOver from 'components/common/popover';

import { DEFAULT_ALLOCATION_HR } from 'constants/dashboard';
import { ALLOCATION_APPEND_TEXT_PLURAL } from 'constants/appConstants';

import TeamsAllocationInfo from './TeamsAllocationInfo';
import AllocationProgressBar from './AllocationProgressBar';

import type { TeamAllocation, TeamAllocationItem } from '../types';

interface AllocationCellContentProps {
  allocationData?: TeamAllocation;
  totalHours: number;
}

const AllocationCellContent = ({ allocationData, totalHours }: AllocationCellContentProps) => {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  const uniqueAllocations = _.uniqBy(
    allocationData?.allocations || [],
    (allocation: TeamAllocationItem) => allocation.name + allocation.type
  );

  if (!uniqueAllocations.length) {
    return <p className="my-team__table-text">-</p>;
  }

  return (
    <PopOver
      interactive
      trigger="mouseenter"
      position="bottom"
      useContext={false}
      theme={'custom-light' as 'light'}
      popperOptions={{
        modifiers: {
          flip: {
            enabled: true,
            behavior: ['bottom', 'top'],
          },
          preventOverflow: { enabled: false },
        },
      }}
      html={<TeamsAllocationInfo currentAllocations={uniqueAllocations} hoveredIndex={hoveredIndex} />}
    >
      <div className="my-team__table-text cursor-pointer my-team__allocation-cell">
        <AllocationProgressBar
          allocations={uniqueAllocations}
          hoveredIndex={hoveredIndex}
          onHoverIndex={setHoveredIndex}
        />
        <span
          className={classNames('my-team__hours', {
            'my-team__hours--over': totalHours > DEFAULT_ALLOCATION_HR,
            'my-team__hours--under': totalHours < DEFAULT_ALLOCATION_HR,
            'my-team__hours--ok': totalHours === DEFAULT_ALLOCATION_HR,
          })}
        >
          {totalHours} {ALLOCATION_APPEND_TEXT_PLURAL}
        </span>
      </div>
    </PopOver>
  );
};

export default AllocationCellContent;
